<template>
  <div class="row">
    <div class="col-md-12">
      <div class="filter-select">
        <vue-select
          :options="equipes"
          label="no_equipe"
          placeholder="Equipes"
          @input="onChangeEquipe"
          :disabled="disabledSelectEquipe"
          :loading="loadingSelectEquipe"
        >
          <template slot="option" slot-scope="option">
            {{ option.no_equipe }}
            {{ option.nu_ine != 'sem-equipe' ? '- ' + option.nu_ine : '' }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
        <vue-select
          :options="profissionais"
          label="no_profissional"
          placeholder="Profissionais"
          @input="onChangeProfissional"
          v-model="select_profissional"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
    </div>
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <Subtitle
            @exibirVermelhos="handleExibirVermelhos"
            @exibirVerdes="handleExibirVerdes"
            @exibirPretos="handleExibirPretos"
            :setRed="setRed"
            :disabledRed="disabledRed"
            :disabledGreen="disabledGreen"
            :disabledBlack="disabledBlack"
            @resetarNome="setRed = false"
          ></Subtitle>
        </div>
        <div class="select-situacao info-table-item">
          <vue-select
            :options="filterMeses"
            label="label"
            placeholder="Meses"
            v-model="filter"
            @input="
              filter !== null
                ? filtros(
                    exibirCadastrosVermelhos,
                    exibirCadastrosVerdes,
                    exibirCadastrosPretos,
                    $event
                  )
                : filtros(
                    exibirCadastrosVermelhos,
                    exibirCadastrosVerdes,
                    exibirCadastrosPretos,
                    {
                      situacao: 'Todos',
                    }
                  )
            "
            :clearable="true"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="dose-imunizante"
          >
          </download-files>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        :vacinasRegistradas="vacinasRegistradas"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import Subtitle from './Subtitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'DoseImunizantePorEquipeAcs',
  metaInfo: {
    title: 'Dose imunizante',
    titleTemplate: null,
  },
  components: {
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      cadastros: [],
      equipe: '',
      profissionais: [],
      profissional: '',
      select_profissional: '',
      page: 1,
      perPage: 12,
      pages: [],
      nome: '',
      idade_inicial: '',
      idade_final: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      nomeEquipe: '',
      nomeProfissional: '',
      vacinasRegistradas: [],
      cadastrosOriginais: [],
      setRed: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      exibirCadastrosPretos: false,
      equipeEvent: '',
      disabledRed: false,
      disabledGreen: false,
      disabledBlack: false,
      disabledSelectEquipe: false,
      loadingSelectEquipe: false,
      filterMeses: [
        { label: '4 meses', value: '4 meses' },
        { label: '5 meses', value: '5 meses' },
        { label: '6 meses', value: '6 meses' },
        { label: '9 meses', value: '9 meses' },
        { label: '12 meses', value: '12 meses' },
        { label: '15 meses', value: '15 meses' },
      ],
      filter: '',
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    equipes() {
      let data = this.$store.getters['getEquipes']
      data.push({
        nu_ine: 'sem-equipe',
        no_equipe: 'SEM EQUIPE',
      })
      return this.removeDuplicate(data, 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros(vermelho, verde, preto, filter) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = Functions.exibirTodos(this.cadastrosOriginais)
      this.exibirCadastrosVerdes = false
      this.exibirCadastrosVermelhos = false
      this.exibirCadastrosPretos = false

      // Se null setar como vazio
      if (filter === null) {
        this.filter = ''
        filter = ''
      }
      if (filter !== '') {
        data = Functions.handleFilter(data, filter.value)
      }
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVerdes = true
      }

      if (preto === true) {
        data = Functions.exibirPretos(data)
        this.exibirCadastrosPretos = true
      }

      this.cadastros = data
      this.total_de_registros_da_tabela = this.cadastros.length
      this.cadastrosPdf = this.cadastros
    },

    handleExibirVermelhos(event) {
      this.loading = true
      this.disabledRed = true
      this.disabledGreen = true
      this.disabledBlack = true
      setTimeout(() => {
        if (event == true) {
          // mostra os vermelhos
          this.filtros(true, false, false, this.filter)
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
          this.exibirCadastrosPretos = false
        } else {
          this.filtros(false, false, false, this.filter)
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.disabledBlack = false
        this.loading = false
      }, 1000)
    },

    handleExibirVerdes(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      this.disabledBlack = true
      setTimeout(() => {
        if (event == true) {
          // mostra os verdes
          this.filtros(false, true, false, this.filter)
          this.exibirCadastrosVerdes = true
          this.exibirCadastrosVermelhos = false
          this.exibirCadastrosPretos = false
        } else {
          this.filtros(false, false, false, this.filter)
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.disabledBlack = false
        this.loading = false
      }, 1000)
    },

    handleExibirPretos(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      this.disabledBlack = true
      setTimeout(() => {
        if (event == true) {
          this.filtros(false, false, true, this.filter)
          this.exibirCadastrosPretos = true
          this.exibirCadastrosVerdes = false
          this.exibirCadastrosVermelhos = false
        } else {
          this.filtros(false, false, false, this.filter)
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.disabledBlack = false
        this.loading = false
      }, 1000)
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.equipeEvent = event
        this.loading = true
        this.equipe = event.nu_ine
        this.nomeProfissional = ''
        this.profissionais = []
        this.profissional = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.select_profissional = ''
        try {
          // Retorna os AGENTES COMUNITÁRIOS de uma equipe de acordo com o ine
          let profissionais = await this.$api.get(
            '/app/profissionais/acs/' + this.cod_ibge + '/' + this.equipe
          )
          if (profissionais) {
            this.profissionais = profissionais.data
            if (event.nu_ine == 'sem-equipe') {
              this.nomeEquipe = 'SEM EQUIPE'
            } else {
              this.nomeEquipe = event.no_equipe
            }
            let response = await this.$api.get(
              '/app/dose-imunizante/equipe/' + this.cod_ibge + '/' + this.equipe
            )
            if (response) {
              this.cadastrosOriginais = response.data
              this.cadastros = response.data
              this.total_de_registros_da_tabela = response.data.length
              this.filtros(true, false, false, this.filter)
              this.setRed = true
              this.loading = false
            }
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        this.nomeProfissional = ''
        this.profissionais = []
        this.profissional = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.select_profissional = ''
        this.equipe = ''
        this.nomeEquipe = ''
        this.equipeEvent = ''

        return
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.profissional = event.nu_cpf
        this.nomeProfissional = event.no_profissional
        this.page = 1
        this.buscarCadastrosIndividuais()
      } else {
        this.profissional = ''
        this.nomeProfissional = ''
        this.select_profissional = ''
        this.onChangeEquipe(this.equipeEvent)
        return
      }
    },

    async buscarCadastrosIndividuais() {
      try {
        this.loading = true
        let response = await this.$api.post(
          '/app/dose-imunizante/profissional',
          {
            co_ibge: this.cod_ibge,
            cpf: this.profissional,
          }
        )
        this.cadastrosOriginais = response.data
        this.cadastros = response.data
        this.total_de_registros_da_tabela = response.data.length
        this.filtros(true, false, false, this.filter)
        this.setRed = true
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipeEvent,
        this.nomeProfissional
      )
    },

    async init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
    },
  },
  created() {
    this.init()
  },
}
</script>

<style></style>
